import createIcon from '../../createIcon';

/**
 * @component @name KeyboardCapslock
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgOC42MTQ5MkwxNi41OSAxMy4yMDQ5TDE4IDExLjc5NDlMMTIgNS43OTQ5Mkw2IDExLjc5NDlMNy40MSAxMy4yMDQ5TDEyIDguNjE0OTJaTTYgMTguMjA0OUgxOFYxNi4yMDQ5SDZWMTguMjA0OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardCapslock = createIcon('KeyboardCapslock', [
  [
    'path',
    {
      d: 'M12 8.61492L16.59 13.2049L18 11.7949L12 5.79492L6 11.7949L7.41 13.2049L12 8.61492ZM6 18.2049H18V16.2049H6V18.2049Z',
      key: '15fykm',
    },
  ],
]);

export default KeyboardCapslock;
